import { HttpClient } from '@angular/common/http';
import { APP_VERSION } from '@configs/app.config';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const createTranslateLoader = (http: HttpClient): TranslateHttpLoader =>
  new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${APP_VERSION}`);
